<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog
            v-model="dialog"
            :persistent="dialog"
            width="900"
            content-class="elevation-0 pa-15 border-radius-3 d-flex justify-center align-center"
            hide-overlay
            :fullscreen="dialog"
        >
            <v-row class="row d-flex justify-center pa-0 ma-0 card-height">
                <v-col cols="5" color="#fff" class="pa-0">
                    <v-card class="border-radius-1 pa-7 h-100">
                        <DiagnosticText :data="diagnosticData[text_index]" />
                    </v-card>
                </v-col>
                <v-col cols="5" class="border-radius-1 pa-0">
                    <v-card
                        class="border-radius-1 pa-7 d-flex h-100 flex-column position-relative"
                        color="#e9f5f4"
                        elevation="12"
                    >
                        <div class="position-absolute bees bee-corner">
                            <img :src="bee_3" class="bee"  alt="bee_3"/>
                        </div>
                        <Question
                            :data="diagnosticData[text_index].preguntas[question_index]"
                            :question_number="question_index + 1"
                            :count_question="diagnosticData[text_index].preguntas.length"
                            @newSelection="newSelection"
                            :cleanSelection="cleanCounter"
                        />
                        <v-card-actions class="d-flex justify-center pa-0 mt-auto ">
                            <v-btn
                                data-cy="diagnosticModal-nextQuestion-button"
                                color="secondary"
                                class="px-10"
                                large
                                rounded
                                @click="nextQuestion"
                                v-if="next_question"
                                >{{ $t('initialTour.next_question') }}</v-btn
                            >
                            <v-btn
                                data-cy="diagnosticModal-nextText-button"
                                color="secondary"
                                class="px-10"
                                large
                                rounded
                                @click="nextText"
                                v-if="next_text"
                                >{{ $t('initialTour.next_text') }}</v-btn
                            >
                            <v-btn
                                data-cy="diagnosticModal-finish-button"
                                color="secondary"
                                class="px-10"
                                large
                                rounded
                                :loading="btnLoaded"
                                @click="nextPass"
                                v-if="next_pass"
                                >{{ $t('initialTour.finish') }}</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import DiagnosticService from '@/services/diagnostic'

import DiagnosticText from './DiagnosticCore/DiagnosticText.vue'
import Question from './DiagnosticCore/Question.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        DiagnosticText,
        Question,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
            answer_body: (state) => state.dashboard.answer_body,
        }),
        next_question() {
            return this.diagnosticData[this.text_index].preguntas.length - 1 > this.question_index
        },
        next_text() {
            return (
                this.diagnosticData[this.text_index].preguntas.length - 1 === this.question_index &&
                this.diagnosticData.length - 1 > this.text_index
            )
        },
        next_pass() {
            return (
                this.diagnosticData.length - 1 === this.text_index &&
                this.diagnosticData[this.text_index].preguntas.length - 1 === this.question_index
            )
        },
    },
    mounted() {
        this.setBookUserIdForDiagnostic(this.user.id)
    },
    data() {
        return {
            text_index: 0,
            question_index: 0,
            // eslint-disable-next-line global-require
            bee_3: require('@/assets/img/bees/bee003.svg'),
            btnLoaded: false,
            cleanCounter: 0,
            selectedId: null,
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'mountDiagnostic',
            'setBookUserIdForDiagnostic',
            'insertDiagnosticoPreguntaRespuesta',
            'showFinishOnBoardingModal',
        ]),
        newSelection(selectionId) {
            this.selectedId = selectionId
        },
        async nextPass() {
            this.btnLoaded = true
            if (this.evaluateValue()){
                await DiagnosticService.answerDiagnostico(this.answer_body).catch((error) =>
                    console.error(error)
                )
                this.mountDiagnostic()
                this.showFinishOnBoardingModal()
                window.ChurnZero.push(['trackEvent', 'finishOnboarding', 'Student has finished onboarding']);
                this.$ga.event('pageLoaded', 'onboardingFinished')
            }
            this.btnLoaded = false

        },
        nextQuestion() {
            if (this.evaluateValue()) {
                this.question_index += 1
            }
        },
        nextText() {
            if (this.evaluateValue()) {
                this.text_index += 1
                this.question_index = 0
            }
        },
        evaluateValue() {
            const preguntas = this.diagnosticData[this.text_index]
            let radioValue = null
            if (this.selectedId !== null) {
                radioValue = this.selectedId
            } else {
                console.log('error, open modal');
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }
            if (radioValue) {
                this.insertDiagnosticoPreguntaRespuesta({
                    preguntaId: preguntas.preguntas[this.question_index].id,
                    respuestaId: radioValue,
                })
                this.cleanCounter += 1
                this.newSelection(null)
            } else {
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }
            return radioValue
        },
    },
}
</script>
<style>
.card-height {
    height: 70vh;
}

.border-main {
    box-shadow: inset 0 0 0 1px #4bada1;
}

.bee-corner {
    top: -6vh;
    right: -6vh;
}
</style>
